export default class PendingRequestViewState {
  isVisible = false;
}
